import React from 'react';
import './Actualitésocial.css';

const Actualitéscial = () => {
    return (
        <div>
            <div className='mere3'>
            <div className='container3'>
            
            <div className='barrets3'>
            <div className='trait3'></div>
            <div className='tiret3a'></div>
            </div>
            <div className='sous-titre3'>
                <h1>A PROPOS</h1>
            </div>
            <div className='tiret3'>
            </div>
            </div>
            </div>
                    {/* Rectangle blanc avec du texte placé juste sous A PROPOS */}
                    <div className="rectangle-blanc3">
                        
                        <ul>
                       <li> Le service social de la Mairie du 2e Arrondissement accompagne les habitants dans leurs démarches sociales, en particulier les familles, les seniors et les personnes en difficulté.</li> <br />
                            <li>Il propose un soutien personnalisé, facilite l'accès aux aides sociales et collabore avec divers partenaires pour répondre aux besoins locaux .</li>
                        </ul>
                    
                    </div>
                </div>  
          
    
    );
};

export default Actualitéscial;


